export default "__VITE_ASSET__CcP7xydc__"